module.exports = __webpack_public_path__ + "static/img/bg_home_all_game_two.010a8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_home_all_game_two.png
// module id = 1Dg6
// module chunks = 0